// extracted by css-extract-rspack-plugin
export default {"helpText":"Development-module__helpText__uyuSO"};